import { gql } from "@apollo/client";

export const GET_FILE_URL = gql`
query getFileUrl($id: String!) {
    getFile(id: $id) {
        fileUrl
    }
}
`